import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../redux/axios";
import {
  getItemWithExpiry,
  removeItemWithExpiry,
  setItemWithExpiry,
} from "../../lib/utility";

const initialState = {
  smscData: [], 
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",

  isFetchingSMSCGroupMember: false,
  isFetchingSMSCGroupMemberCreate: false,
  isFetchingSMSCGroupMemberDelete: false,
  isFetchingGroupMemberUpdate: false,

  flagData: [],
  statusData: [],

  createSmsc: {},
  isSuccessCreateSmsc: false,
  isErrorCreateSmsc: false,
  isErrorMessageCreateSmsc: "",

  smscLimitsData: [],
  smscLoopingData: {
    data: [],
    totalItems: 0,
    totalPages: 1,
    currentPage: 0,
    pageSize: 10,
  },
  smscHLRData: [],
  smscHLRStatusData: [],
  smscScheduleData: [],
  smscBlockingData: [],
  smscGroupData: [],
  smscGroupMemberData: [],

  httpSmscData: [],
  isFetchingHttpSmsc: false,
  isFetchingCreateHttpSmsc: false,
  isFetchingEditHttpSmsc: false,
  isFetchingDeleteHttpSmsc: false,
  isFetchingTestHttpSmsc: false,
  isFetchingGetHttpSmscById: false,
  httpSmscByIdData: null,

  errorCodeSmscData: {
    data: [],
    totalItems: 0,
    currentPage: 0,
    totalPages: 0,
  },
  isFetchingErrorCodeSmsc: false,
  isFetchingCreateErrorCodeSmsc: false,
  isFetchingEditErrorCodeSmsc: false,
  isFetchingDeleteErrorCodeSmsc: false,
};

export const getSmscCustomData = createAsyncThunk(
  "smsc/get-all-smsc-custom", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      let url = `/smsc/status?purpose=` + udata.purpose;

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("err ===>", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscDataForAdmin = createAsyncThunk(
  "smsc/get-all-smsc-admin", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      let url = `/smsc/smscEntries/matching`;

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("err ===>", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscAllData = createAsyncThunk(
  "smsc/get-all-smsc-entries", 
  async (udata, thunkAPI) => {
    try {
      if (udata?.purpose === "list" || udata?.page !== undefined) {
        const { auth } = thunkAPI.getState();
        let tokenStr = auth.user.accessToken;

        const params = new URLSearchParams();
        if (udata?.page !== undefined) params.append("page", udata.page);
        if (udata?.size !== undefined) params.append("size", udata.size);
        if (udata?.sortBy) params.append("sortBy", udata.sortBy);
        if (udata?.sortDir) params.append("sortDir", udata.sortDir);
        if (udata?.search) params.append("search", udata.search);
        
        if (udata?.startDate) params.append("startDate", udata.startDate);
        if (udata?.endDate) params.append("endDate", udata.endDate);
        if (udata?.toGmt !== undefined) params.append("toGmt", udata.toGmt);
        if (udata?.systemId) params.append("systemId", udata.systemId);
        if (udata?.masterId) params.append("masterId", udata.masterId);
        if (udata?.bound !== undefined) params.append("bound", udata.bound);

        const queryString = params.toString();
        const url = `/smsc/smscEntries-all${
          queryString ? `?${queryString}` : ""
        }`;

        const { data, status } = await axios.get(url, {
          headers: { Authorization: `Bearer ${tokenStr}` },
        });

        if (status.toString().startsWith("2")) {
          return { data, status };
        } else {
          return thunkAPI.rejectWithValue({ ...data, status });
        }
      } else {
        const smscList = getItemWithExpiry("smscList");
        if (smscList) {
          return { data: smscList, status: 200 };
        }
        const { auth } = thunkAPI.getState();
        let tokenStr = auth.user.accessToken;
        let url = `/smsc/smscEntries-all?purpose=edit`;

        const { data, status } = await axios.get(url, {
          headers: { Authorization: `Bearer ${tokenStr}` },
        });

        if (status.toString().startsWith("2")) {
          setItemWithExpiry("smscList", data, 10800);
          return { data, status };
        } else {
          return thunkAPI.rejectWithValue({ ...data, status });
        }
      }
    } catch (err) {
      console.error("err ===>", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const getSmscData = createAsyncThunk(
  "smsc/get-all-smsc",
  async (udata, thunkAPI) => {
    try {
      if (udata?.purpose === "list" || udata?.page !== undefined) {
        const { auth } = thunkAPI.getState();
        const tokenStr = auth.user.accessToken;

        
        const url = `/smsc/smscEntries`;

        const { data, status } = await axios.get(url, {
          headers: { Authorization: `Bearer ${tokenStr}` },
        });

        if (status.toString().startsWith("2")) {
          return { data, status };
        } else {
          return thunkAPI.rejectWithValue({ ...data, status });
        }
      } else {
        
        const smscList = getItemWithExpiry("smscList");
        if (smscList) {
          return { data: smscList, status: 200 };
        }

        const { auth } = thunkAPI.getState();
        const tokenStr = auth.user.accessToken;

        const url = `/smsc/smscEntries?purpose=edit`;

        const { data, status } = await axios.get(url, {
          headers: { Authorization: `Bearer ${tokenStr}` },
        });

        if (status.toString().startsWith("2")) {
          setItemWithExpiry("smscList", data, 10800); 
          return { data, status };
        } else {
          return thunkAPI.rejectWithValue({ ...data, status });
        }
      }
    } catch (err) {
      console.error("err ===>", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const createSmscData = createAsyncThunk(
  "smsc/create-smsc",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/smsc/save", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const checkSmscFirewall = createAsyncThunk(
  "smsc/check-firewall",
  async (smscName, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const username = auth.user.username ?? auth.user.systemId ?? "";

      const { data, status } = await axios.get(
        `/smsc/check-firewall?smscName=${encodeURIComponent(smscName)}`,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            username,
          },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const deleteSmscFirewall = createAsyncThunk(
  "smsc/delete-firewall",
  async (profileName, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const username = auth.user.username ?? auth.user.systemId ?? "";

      const { data, status } = await axios.delete(
        `/firewall/delete?profilename=${encodeURIComponent(profileName)}`,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            username,
          },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const deleteSmscData = createAsyncThunk(
  "smsc/delete-smsc",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(`/smsc/delete/${udata}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSingleSmscData = createAsyncThunk(
  "smsc/data-smsc-single",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(`/smsc/get?id=${udata}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscData = createAsyncThunk(
  "smsc/update-smsc",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        `/smsc/update/${udata.id}`,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getHttpSmscById = createAsyncThunk(
  "smsc/http-smsc-get-by-id",
  async (systemId, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.get(`/http-smsc/${systemId}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const getSmscFlag = createAsyncThunk(
  "smsc/get-smsc-flag",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;

      const params = new URLSearchParams();

      if (udata?.page !== undefined) params.append("page", udata.page);
      if (udata?.size !== undefined) params.append("size", udata.size);
      if (udata?.sortBy) params.append("sortBy", udata.sortBy);
      if (udata?.sortDirection)
        params.append("sortDirection", udata.sortDirection);
      if (udata?.search) params.append("search", udata.search);

      const queryString = params.toString();
      const url = `/smsc/smscFlag-entries${
        queryString ? `?${queryString}` : ""
      }`;

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const updateSmscFlag = createAsyncThunk(
  "smsc/update-smsc-flag",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const params = new URLSearchParams();
      if (udata.smscId === "ALL") {
        params.append("smscNames", "");
      } else if (Array.isArray(udata.smscId)) {
        udata.smscId.forEach((name) => params.append("smscNames", name));
      } else if (udata.smscId) {
        params.append("smscNames", udata.smscId);
      }
      params.append("option", udata.option);

      const { data, status } = await axios.post(
        "/smsc/flagBinding?" + params.toString(),
        {},
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscStatus = createAsyncThunk(
  "smsc/get-smsc-status",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;

      const params = new URLSearchParams({ purpose: "status" });

      if (udata?.sortBy) params.append("sortBy", udata.sortBy);
      if (udata?.sortDirection)
        params.append("sortDirection", udata.sortDirection);

      if (udata?.search) params.append("search", udata.search);
      const { data, status } = await axios.get(
        `/smsc/status?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getSmscLimitsData = createAsyncThunk(
  "smsc/limit-list",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      let url = `/smsc/list`;

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        data: err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const createSmscLimitsData = createAsyncThunk(
  "smsc/limit-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/smsc/limit/save", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const deleteSmscLimitsData = createAsyncThunk(
  "smsc/limit-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/smsc/deleteLimit/${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscLimitsData = createAsyncThunk(
  "smsc/limit-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        `/smsc/updateLimit/${udata.id}`,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscLoopingData = createAsyncThunk(
  "smsc/looping-list",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      let url;
      if (typeof udata === "string") {
        url = `/smsc/looping/list${udata}`;
      } else {
        const params = new URLSearchParams();
        if (udata?.pageNumber !== undefined)
          params.append("page", udata.pageNumber);
        if (udata?.pageSize !== undefined)
          params.append("size", udata.pageSize);
        if (udata?.searchTerm) params.append("search", udata.searchTerm);
        if (udata?.sortBy) params.append("sortBy", udata.sortBy);
        if (udata?.sortDirection)
          params.append("sortDirection", udata.sortDirection);

        const queryString = params.toString();
        url = `/smsc/looping/list${queryString ? `?${queryString}` : ""}`;
      }

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data: { ...data, pageSize: udata.pageSize || 10 }, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const createSmscLoopingData = createAsyncThunk(
  "smsc/looping-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/smsc/looping/save", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const deleteSmscLoopingData = createAsyncThunk(
  "smsc/looping-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/smsc/smsclooping/deleteLoopingRule/${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscLoopingData = createAsyncThunk(
  "smsc/looping-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(`/smsc/looping/update`, udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const updateSmscHLRFlagData = createAsyncThunk(
  "smsc/hlr-flag-update",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const params = new URLSearchParams();
      if (udata.smscId === "ALL") {
        params.append("smscNames", "");
      } else if (Array.isArray(udata.smscId)) {
        udata.smscId.forEach((name) => params.append("smscNames", name));
      } else if (udata.smscId) {
        params.append("smscNames", udata.smscId);
      }
      params.append("option", udata.option);

      const { data, status } = await axios.post(
        "/hlr/flagBinding?" + params.toString(),
        {},
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscHLRStatusData = createAsyncThunk(
  "smsc/hlr-status-list",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const params = new URLSearchParams();
      if (udata?.pageNumber !== undefined)
        params.append("page", udata.pageNumber);
      if (udata?.pageSize !== undefined) params.append("size", udata.pageSize);
      if (udata?.search) params.append("search", udata.search);
      if (udata?.sortBy) params.append("sortBy", udata.sortBy);
      if (udata?.sortDirection)
        params.append("sortDirection", udata.sortDirection);
      params.append("purpose", "status");

      const queryString = params.toString();
      const url = `/hlr/get-all?${queryString}`;

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscHLRData = createAsyncThunk(
  "smsc/hlr-list",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const params = new URLSearchParams();
      if (udata?.pageNumber !== undefined)
        params.append("page", udata.pageNumber);
      if (udata?.pageSize !== undefined) params.append("size", udata.pageSize);
      if (udata?.search) params.append("search", udata.search);
      if (udata?.sortBy) params.append("sortBy", udata.sortBy);
      if (udata?.sortDirection)
        params.append("sortDirection", udata.sortDirection);
      params.append("purpose", udata?.purpose || "list");
      
      if (udata?.name) params.append("name", udata.name);
      if (udata?.systemId) params.append("systemId", udata.systemId);
      if (udata?.bound !== undefined) params.append("bound", udata.bound);

      const queryString = params.toString();
      const url = `/hlr/get-all?${queryString}`;

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const createSmscHLRData = createAsyncThunk(
  "smsc/hlr-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/hlr/save-hlr-smsc", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const deleteSmscHLRData = createAsyncThunk(
  "smsc/hlr-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/hlr/delete-hlr-smsc/${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscHLRSingleData = createAsyncThunk(
  "smsc/hlr-edit-single",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(`/hlr/get-hlr-smsc/${udata}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscHLRData = createAsyncThunk(
  "smsc/hlr-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        `/hlr/update-hlr-smsc/${udata.id}`,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscScheduleData = createAsyncThunk(
  "smsc/schedule-list", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const params = new URLSearchParams();
      if (udata?.pageNumber !== undefined)
        params.append("page", udata.pageNumber);
      if (udata?.pageSize !== undefined) params.append("size", udata.pageSize);
      if (udata?.searchTerm) params.append("searchTerm", udata.searchTerm);
      if (udata?.sortBy) params.append("sortBy", udata.sortBy);
      if (udata?.sortDirection) params.append("sortDir", udata.sortDirection);

      const queryString = params.toString();
      const url = `smsc/trafficSchedule/list${
        queryString ? `?${queryString}` : ""
      }`;

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        data: err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const createSmscScheduleData = createAsyncThunk(
  "smsc/schedule-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/smsc/schedule/save", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const deleteSmscScheduleData = createAsyncThunk(
  "smsc/schedule-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/smsc/schedule/delete/${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscScheduleData = createAsyncThunk(
  "smsc/schedule-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(`/smsc/schedule/update`, udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscBlockingData = createAsyncThunk(
  "smsc/blocking-list", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.get("/smsc/blocking/list", {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        data: err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const createSmscBlockingData = createAsyncThunk(
  "smsc/blocking-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/smsc/blocking/save", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const deleteSmscBlockingData = createAsyncThunk(
  "smsc/blocking-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/smsc/blocking/delete/${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscBlockingData = createAsyncThunk(
  "smsc/blocking-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(`/smsc/update/blocking`, udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscGroupData = createAsyncThunk(
  "smsc/group-list", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.get("/smsc/group/list", {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue({ data, status });
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        data: err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const createSmscGroupData = createAsyncThunk(
  "smsc/group-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/smsc/group/save", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const deleteSmscGroupData = createAsyncThunk(
  "smsc/group-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/smsc/group/delete/${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscGroupData = createAsyncThunk(
  "smsc/group-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(`/smsc/group/update`, udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getSmscGroupMemberData = createAsyncThunk(
  "smsc/groupMember-list", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.get("/smsc/groupMember/" + udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue({ data, status });
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        data: err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const createSmscGroupMemberData = createAsyncThunk(
  "smsc/groupMember-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post(
        "/smsc/groupMember/save",
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const deleteSmscGroupMemberData = createAsyncThunk(
  "smsc/groupMember-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/smsc/groupmember/delete/{groupMemberId}?groupMemberId=${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscGroupMemberData = createAsyncThunk(
  "smsc/groupMember-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        `/smsc/groupmember/update?groupMemberID=` + udata.groupId,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const createSmscSpecialSettingData = createAsyncThunk(
  "smsc/specialSetting-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post(
        "/smsc/specialSetting/save",
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const deleteSmscSpecialSettingData = createAsyncThunk(
  "smsc/specialSetting-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/smsc/SpecialSetting/${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscSpecialSettingData = createAsyncThunk(
  "smsc/specialSetting-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        `/smsc/SpecialSetting/` + udata.smscId,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const editSmscSingleSpecialSettingData = createAsyncThunk(
  "smsc/specialSetting-edit-single",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(
        `/smsc/SpecialSetting/` + udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getHttpSmscData = createAsyncThunk(
  "smsc/http-get", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const urlSearchParams = new URLSearchParams();

      if (udata.search) urlSearchParams.append("search", udata.search);
      if (udata.page !== undefined && typeof udata.page === 'number' && !isNaN(udata.page)) {
        urlSearchParams.append("pageNumber", Math.max(0, Math.floor(udata.page)));
      }
      if (udata.size !== undefined && typeof udata.size === 'number' && !isNaN(udata.size) && udata.size > 0) {
        urlSearchParams.append("pageSize", Math.floor(udata.size));
      }
      if (udata.sortBy) urlSearchParams.append("sortBy", udata.sortBy); 
      if (udata.sortDirection)
        urlSearchParams.append("sortDirection", udata.sortDirection); 
      
      
      if (udata.udata?.systemId && udata.udata.systemId.trim() !== "") {
        urlSearchParams.append("systemId", udata.udata.systemId.trim());
      }
      if (udata.udata?.providerType && udata.udata.providerType.trim() !== "") {
        urlSearchParams.append("providerType", udata.udata.providerType.trim());
      }
      if (udata.udata?.dlrStatus && udata.udata.dlrStatus.trim() !== "") {
        urlSearchParams.append("dlrStatus", udata.udata.dlrStatus.trim());
      }

      const finalUrl = "/http-smsc?" + urlSearchParams.toString();
      
      const { data, status } = await axios.get(
        finalUrl,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue({ data, status });
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        data: err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const createHttpSmscData = createAsyncThunk(
  "smsc/http-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/http-smsc", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const editHttpSmscData = createAsyncThunk(
  "smsc/http-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        `/http-smsc/` + udata.systemId,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const deleteHttpSmscData = createAsyncThunk(
  "smsc/http-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(`/http-smsc/${udata}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const updateHttpSmscFlag = createAsyncThunk(
  "smsc/http-smsc-flag", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const params = new URLSearchParams();
      if (udata.ids === "ALL") {
        params.append("systemNames", "");
      } else if (Array.isArray(udata.ids)) {
        udata.ids.forEach((name) => params.append("systemNames", name));
      } else if (udata.ids) {
        params.append("systemNames", udata.ids);
      }
      params.append("option", udata.option);

      const { data, status } = await axios.post(
        "/http-smsc/flagBinding?" + params.toString(),
        {},
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const testHttpSmsc = createAsyncThunk(
  "smsc/http-smsc-test", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post(
        "/http-smsc/connection",
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        data: err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const getErrorCodeSmscData = createAsyncThunk(
  "smsc/error-code-get",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const params = new URLSearchParams();
      if (udata?.pageNumber !== undefined)
        params.append("page", udata.pageNumber);
      if (udata?.pageSize !== undefined) params.append("size", udata.pageSize);
      if (udata?.search) params.append("search", udata.search);
      if (udata?.sortBy) params.append("sortBy", udata.sortBy);
      if (udata?.sortDirection) params.append("sortDir", udata.sortDirection);
      if (udata?.errorName) params.append("errorName", udata.errorName);
      if (udata?.flagSymbol) params.append("flagSymbol", udata.flagSymbol);
      if (udata?.errorStatus) params.append("errorStatus", udata.errorStatus);

      const queryString = params.toString();
      const url = `/smsc/smsc-error-codes/get-all${
        queryString ? `?${queryString}` : ""
      }`;

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue({ data, status });
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        data: err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const createErrorCodeSmscData = createAsyncThunk(
  "smsc/error-code-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post(
        "/smsc/smsc-error-codes/create",
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const editErrorCodeSmscData = createAsyncThunk(
  "smsc/error-code-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        `/smsc/smsc-error-codes/update/` + udata.flagVal,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const deleteErrorCodeSmscData = createAsyncThunk(
  "smsc/error-code-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/smsc/smsc-error-codes/delete/${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const smscSlice = createSlice({
  name: "smsc",
  initialState,
  reducers: {
    clearStateSmsc: (state, { payload }) => {
      state.smscData = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
    },
    clearStateCreateSmsc: (state, { payload }) => {
      state.createSmsc = {};
      state.isFetching = false;
      state.isSuccessCreateSmsc = false;
      state.isErrorCreateSmsc = false;
      state.isErrorMessageCreateSmsc = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSmscDataForAdmin.fulfilled, (state, action) => {
        state.smscData = action.payload.data;
        state.isFetching = false;
        state.isSuccess = true;
      })
      .addCase(getSmscDataForAdmin.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscDataForAdmin.rejected, (state, action) => {
        state.smscData = [];
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(getSmscData.fulfilled, (state, action) => {
        
        if (Array.isArray(action.payload.data)) {
          state.smscData = action.payload.data;
        } else if (
          action.payload.data?.data &&
          Array.isArray(action.payload.data.data)
        ) {
          state.smscData = action.payload.data.data;
        } else {
          state.smscData = action.payload.data;
        }
        state.isFetching = false;
        state.isSuccess = true;
      })
      .addCase(getSmscData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscData.rejected, (state, action) => {
        state.smscData = [];
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(getSmscAllData.fulfilled, (state, action) => {
        
        if (Array.isArray(action.payload.data)) {
          state.smscData = action.payload.data;
        } else if (
          action.payload.data?.data &&
          Array.isArray(action.payload.data.data)
        ) {
          state.smscData = action.payload.data.data;
        } else {
          state.smscData = action.payload.data;
        }
        state.isFetching = false;
        state.isSuccess = true;
      })
      .addCase(getSmscAllData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscAllData.rejected, (state, action) => {
        state.smscData = [];
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(createSmscData.fulfilled, (state, action) => {
        state.createSmsc = action.payload;
        state.isFetching = false;
        state.isSuccessCreateSmsc = true;
        removeItemWithExpiry("smscList");
        removeItemWithExpiry("smscNames");
      })
      .addCase(createSmscData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createSmscData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorCreateSmsc = true;
        state.isErrorMessageCreateSmsc = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(deleteSmscData.fulfilled, (state, action) => {
        state.isFetching = false;
        removeItemWithExpiry("smscList");
        removeItemWithExpiry("smscNames");
        if (state.smscData.length === 1) state.smscData = [];
      })
      .addCase(deleteSmscData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteSmscData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscData.fulfilled, (state, action) => {
        state.isFetching = false;
        removeItemWithExpiry("smscList");
        removeItemWithExpiry("smscNames");
      })
      .addCase(editSmscData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getSmscFlag.fulfilled, (state, action) => {
        state.isFetching = false;
        state.flagData = action.payload.data;
      })
      .addCase(getSmscFlag.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscFlag.rejected, (state, action) => {
        state.flagData = [];
        state.isFetching = false;
      })
      .addCase(getSmscStatus.fulfilled, (state, action) => {
        state.isFetching = false;
        state.statusData = action.payload.data;
      })
      .addCase(getSmscStatus.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscStatus.rejected, (state, action) => {
        state.statusData = [];
        state.isFetching = false;
      })
      .addCase(getSmscLimitsData.fulfilled, (state, action) => {
        state.isFetching = false;
        state.smscLimitsData = action.payload.data;
      })
      .addCase(getSmscLimitsData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscLimitsData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(createSmscLimitsData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(createSmscLimitsData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createSmscLimitsData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(deleteSmscLimitsData.fulfilled, (state, action) => {
        state.isFetching = false;
        if (state.smscLimitsData.length === 1) state.smscLimitsData = [];
      })
      .addCase(deleteSmscLimitsData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteSmscLimitsData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscLimitsData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscLimitsData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscLimitsData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getSmscLoopingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscLoopingData.fulfilled, (state, action) => {
        state.isFetching = false;
        const apiResponse = action.payload?.data ?? {};
        const requestedPageSize = action.meta?.arg?.pageSize || 10;
        const requestedPageNumber = action.meta?.arg?.pageNumber ?? 0;
        const rows = Array.isArray(apiResponse.data)
          ? apiResponse.data
          : Array.isArray(apiResponse.content)
          ? apiResponse.content
          : Array.isArray(apiResponse)
          ? apiResponse
          : [];

        state.smscLoopingData = {
          data: rows,
          totalItems:
            apiResponse.totalItems ??
            apiResponse.totalElements ??
            rows.length ??
            0,
          totalPages: apiResponse.totalPages ?? (rows.length ? 1 : 0),
          currentPage:
            apiResponse.currentPage ??
            apiResponse.pageNumber ??
            apiResponse.number ??
            requestedPageNumber,
          pageSize:
            apiResponse.pageSize ?? apiResponse.size ?? requestedPageSize,
        };
      })
      .addCase(getSmscLoopingData.rejected, (state, action) => {
        state.isFetching = false;
        state.smscLoopingData = {
          data: [],
          totalItems: 0,
          totalPages: 0,
          currentPage: 0,
          pageSize: action.meta?.arg?.pageSize || 10,
        };
      })
      .addCase(createSmscLoopingData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(createSmscLoopingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createSmscLoopingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(deleteSmscLoopingData.fulfilled, (state, action) => {
        state.isFetching = false;
        if (state.smscLoopingData.length === 1) state.smscLoopingData = [];
      })
      .addCase(deleteSmscLoopingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteSmscLoopingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscLoopingData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscLoopingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscLoopingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getSmscHLRStatusData.fulfilled, (state, action) => {
        state.isFetching = false;
        state.smscHLRStatusData = action.payload.data;
      })
      .addCase(getSmscHLRStatusData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscHLRStatusData.rejected, (state, action) => {
        state.isFetching = false;
        state.smscHLRData = [];
      })
      .addCase(updateSmscHLRFlagData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(updateSmscHLRFlagData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(updateSmscHLRFlagData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getSmscHLRData.fulfilled, (state, action) => {
        state.isFetching = false;
        state.smscHLRData = action.payload.data;
      })
      .addCase(getSmscHLRData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscHLRData.rejected, (state, action) => {
        state.isFetching = false;
        state.smscHLRData = [];
      })
      .addCase(createSmscHLRData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(createSmscHLRData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createSmscHLRData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(deleteSmscHLRData.fulfilled, (state, action) => {
        state.isFetching = false;
        if (state.smscHLRData.length === 1) state.smscHLRData = [];
      })
      .addCase(deleteSmscHLRData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteSmscHLRData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscHLRSingleData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscHLRSingleData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscHLRSingleData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscHLRData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscHLRData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscHLRData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getSmscBlockingData.fulfilled, (state, action) => {
        state.isFetching = false;
        state.smscBlockingData = action.payload.data;
      })
      .addCase(getSmscBlockingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscBlockingData.rejected, (state, action) => {
        state.isFetching = false;
        state.smscBlockingData = [];
      })
      .addCase(createSmscBlockingData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(createSmscBlockingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createSmscBlockingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(deleteSmscBlockingData.fulfilled, (state, action) => {
        state.isFetching = false;
        if (state.smscBlockingData.length === 1) state.smscBlockingData = [];
      })
      .addCase(deleteSmscBlockingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteSmscBlockingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscBlockingData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscBlockingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscBlockingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getSmscScheduleData.fulfilled, (state, action) => {
        state.isFetching = false;
        state.smscScheduleData = action.payload.data;
      })
      .addCase(getSmscScheduleData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscScheduleData.rejected, (state, action) => {
        state.isFetching = false;
        state.smscScheduleData = [];
      })
      .addCase(createSmscScheduleData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(createSmscScheduleData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createSmscScheduleData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(deleteSmscScheduleData.fulfilled, (state, action) => {
        state.isFetching = false;
        if (state.smscScheduleData.length === 1) state.smscScheduleData = [];
      })
      .addCase(deleteSmscScheduleData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteSmscScheduleData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscScheduleData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscScheduleData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscScheduleData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getSmscGroupData.fulfilled, (state, action) => {
        state.isFetching = false;
        state.smscGroupData = action.payload.data;
      })
      .addCase(getSmscGroupData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscGroupData.rejected, (state, action) => {
        state.isFetching = false;
        state.smscGroupData = [];
      })
      .addCase(createSmscGroupData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(createSmscGroupData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createSmscGroupData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(deleteSmscGroupData.fulfilled, (state, action) => {
        state.isFetching = false;
        if (state.smscGroupData.length === 1) state.smscGroupData = [];
      })
      .addCase(deleteSmscGroupData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteSmscGroupData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscGroupData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscGroupData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscGroupData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getSmscGroupMemberData.fulfilled, (state, action) => {
        state.isFetchingSMSCGroupMember = false;
        state.smscGroupMemberData = action.payload?.data?.members;
      })
      .addCase(getSmscGroupMemberData.pending, (state) => {
        state.isFetchingSMSCGroupMember = true;
      })
      .addCase(getSmscGroupMemberData.rejected, (state, action) => {
        state.isFetchingSMSCGroupMember = false;
        state.smscGroupMemberData = [];
      })
      .addCase(createSmscGroupMemberData.fulfilled, (state, action) => {
        state.isFetchingSMSCGroupMemberCreate = false;
      })
      .addCase(createSmscGroupMemberData.pending, (state) => {
        state.isFetchingSMSCGroupMemberCreate = true;
      })
      .addCase(createSmscGroupMemberData.rejected, (state, action) => {
        state.isFetchingSMSCGroupMemberCreate = false;
      })
      .addCase(deleteSmscGroupMemberData.fulfilled, (state, action) => {
        state.isFetchingSMSCGroupMemberDelete = false;
        if (state.smscGroupMemberData.length === 1)
          state.smscGroupMemberData = [];
      })
      .addCase(deleteSmscGroupMemberData.pending, (state) => {
        state.isFetchingSMSCGroupMemberDelete = true;
      })
      .addCase(deleteSmscGroupMemberData.rejected, (state, action) => {
        state.isFetchingSMSCGroupMemberDelete = false;
      })
      .addCase(editSmscGroupMemberData.fulfilled, (state, action) => {
        state.isFetchingGroupMemberUpdate = false;
      })
      .addCase(editSmscGroupMemberData.pending, (state) => {
        state.isFetchingGroupMemberUpdate = true;
      })
      .addCase(editSmscGroupMemberData.rejected, (state, action) => {
        state.isFetchingGroupMemberUpdate = false;
      })
      .addCase(createSmscSpecialSettingData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(createSmscSpecialSettingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createSmscSpecialSettingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(deleteSmscSpecialSettingData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(deleteSmscSpecialSettingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteSmscSpecialSettingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscSpecialSettingData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscSpecialSettingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscSpecialSettingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscSingleSpecialSettingData.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(editSmscSingleSpecialSettingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editSmscSingleSpecialSettingData.rejected, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getHttpSmscData.fulfilled, (state, action) => {
        state.isFetchingHttpSmsc = false;
        state.httpSmscData = action.payload.data.data;
      })
      .addCase(getHttpSmscData.pending, (state) => {
        state.isFetchingHttpSmsc = true;
      })
      .addCase(getHttpSmscData.rejected, (state, action) => {
        state.isFetchingHttpSmsc = false;
        state.httpSmscData = [];
      })
      .addCase(createHttpSmscData.fulfilled, (state, action) => {
        state.isFetchingCreateHttpSmsc = false;
      })
      .addCase(createHttpSmscData.pending, (state) => {
        state.isFetchingCreateHttpSmsc = true;
      })
      .addCase(createHttpSmscData.rejected, (state) => {
        state.isFetchingCreateHttpSmsc = false;
      })
      .addCase(deleteHttpSmscData.fulfilled, (state) => {
        state.isFetchingDeleteHttpSmsc = false;
        if (state.httpSmscData.length === 1) state.httpSmscData = [];
      })
      .addCase(deleteHttpSmscData.pending, (state) => {
        state.isFetchingDeleteHttpSmsc = true;
      })
      .addCase(deleteHttpSmscData.rejected, (state, action) => {
        state.isFetchingDeleteHttpSmsc = false;
      })
      .addCase(editHttpSmscData.fulfilled, (state, action) => {
        state.isFetchingEditHttpSmsc = false;
      })
      .addCase(editHttpSmscData.pending, (state) => {
        state.isFetchingEditHttpSmsc = true;
      })
      .addCase(editHttpSmscData.rejected, (state, action) => {
        state.isFetchingEditHttpSmsc = false;
      })
      .addCase(testHttpSmsc.fulfilled, (state, action) => {
        state.isFetchingTestHttpSmsc = false;
      })
      .addCase(testHttpSmsc.pending, (state) => {
        state.isFetchingTestHttpSmsc = true;
      })
      .addCase(testHttpSmsc.rejected, (state, action) => {
        state.isFetchingTestHttpSmsc = false;
      })
      .addCase(getHttpSmscById.fulfilled, (state, action) => {
        state.isFetchingGetHttpSmscById = false;
        state.httpSmscByIdData = action.payload.data;
      })
      .addCase(getHttpSmscById.pending, (state) => {
        state.isFetchingGetHttpSmscById = true;
      })
      .addCase(getHttpSmscById.rejected, (state, action) => {
        state.isFetchingGetHttpSmscById = false;
        state.httpSmscByIdData = null;
      })
      .addCase(getErrorCodeSmscData.fulfilled, (state, action) => {
        state.isFetchingErrorCodeSmsc = false;

        const apiResponse = action.payload?.data;
        const requestedPageSize = action.meta?.arg?.pageSize || 10;

        let errorCodeArray = [];
        let totalItems = 0;
        let currentPage = 0;
        let totalPages = 0;

        if (apiResponse) {
          if (Array.isArray(apiResponse)) {
            errorCodeArray = apiResponse.filter(
              (item) =>
                item &&
                typeof item === "object" &&
                item.constructor === Object &&
                (item.errorName ||
                  item.flagSymbol ||
                  item.flagVal !== undefined)
            );
            totalItems = errorCodeArray.length;
            currentPage = 0;
            totalPages =
              requestedPageSize > 0
                ? Math.ceil(totalItems / requestedPageSize)
                : 0;
          } else if (apiResponse.data && Array.isArray(apiResponse.data)) {
            errorCodeArray = apiResponse.data;
            totalItems =
              apiResponse.totalItems ??
              apiResponse.totalElements ??
              errorCodeArray.length;
            currentPage = Math.max(0, apiResponse.currentPage ?? 0);
            totalPages =
              apiResponse.totalPages ??
              (requestedPageSize > 0
                ? Math.ceil(totalItems / requestedPageSize)
                : 0);
          } else if (apiResponse.content && Array.isArray(apiResponse.content)) {
            errorCodeArray = apiResponse.content;
            totalItems =
              apiResponse.totalItems ??
              apiResponse.totalElements ??
              errorCodeArray.length;
            currentPage = Math.max(
              0,
              apiResponse.currentPage ?? apiResponse.number ?? 0
            );
            totalPages =
              apiResponse.totalPages ??
              (requestedPageSize > 0
                ? Math.ceil(totalItems / requestedPageSize)
                : 0);
          } else {
            const keys = Object.keys(apiResponse);
            const numericKeys = keys.filter(
              (k) => !isNaN(parseInt(k)) && isFinite(k)
            );

            if (numericKeys.length > 0) {
              errorCodeArray = numericKeys
                .map((k) => apiResponse[parseInt(k)])
                .filter(
                  (item) =>
                    item &&
                    typeof item === "object" &&
                    (item.errorName ||
                      item.flagSymbol ||
                      item.flagVal !== undefined)
                );
              totalItems = apiResponse.totalItems ?? errorCodeArray.length;
              currentPage = Math.max(0, apiResponse.currentPage ?? 0);
              totalPages =
                apiResponse.totalPages ??
                (requestedPageSize > 0
                  ? Math.ceil(totalItems / requestedPageSize)
                  : 0);
            }
          }

          currentPage = Math.max(0, Math.floor(currentPage));
        }

        state.errorCodeSmscData = {
          data: errorCodeArray,
          totalItems,
          currentPage,
          totalPages,
        };
      })
      .addCase(getErrorCodeSmscData.pending, (state) => {
        state.isFetchingErrorCodeSmsc = true;
      })
      .addCase(getErrorCodeSmscData.rejected, (state, action) => {
        state.isFetchingErrorCodeSmsc = false;
        state.errorCodeSmscData = {
          data: [],
          totalItems: 0,
          currentPage: 0,
          totalPages: 0,
        };
      })
      .addCase(createErrorCodeSmscData.fulfilled, (state, action) => {
        state.isFetchingCreateErrorCodeSmsc = false;
      })
      .addCase(createErrorCodeSmscData.pending, (state) => {
        state.isFetchingCreateErrorCodeSmsc = true;
      })
      .addCase(createErrorCodeSmscData.rejected, (state) => {
        state.isFetchingCreateErrorCodeSmsc = false;
      })
      .addCase(deleteErrorCodeSmscData.fulfilled, (state) => {
        state.isFetchingDeleteErrorCodeSmsc = false;
        if (state.errorCodeSmscData.length === 1) state.errorCodeSmscData = [];
      })
      .addCase(deleteErrorCodeSmscData.pending, (state) => {
        state.isFetchingDeleteErrorCodeSmsc = true;
      })
      .addCase(deleteErrorCodeSmscData.rejected, (state, action) => {
        state.isFetchingDeleteErrorCodeSmsc = false;
      })
      .addCase(editErrorCodeSmscData.fulfilled, (state, action) => {
        state.isFetchingEditErrorCodeSmsc = false;
      })
      .addCase(editErrorCodeSmscData.pending, (state) => {
        state.isFetchingEditErrorCodeSmsc = true;
      })
      .addCase(editErrorCodeSmscData.rejected, (state, action) => {
        state.isFetchingEditErrorCodeSmsc = false;
      });
  },
});

export const {
  clearStateSmsc,
  clearStateCreateSmsc,
  clearStateDeleteSmsc,
  clearStateEditSmsc,
} = smscSlice.actions;

export function clearState() {
  return async (dispatch) => {
    dispatch(clearStateSmsc());
  };
}

export function clearStateCreate() {
  return async (dispatch) => {
    dispatch(clearStateCreateSmsc());
  };
}

export function clearStateDelete() {
  return async (dispatch) => {
    dispatch(clearStateDeleteSmsc());
  };
}

export function clearStateEdit() {
  return async (dispatch) => {
    dispatch(clearStateEditSmsc());
  };
}

export const smscSelector = (state) => state.smsc;

export default smscSlice.reducer;
